import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationExtras,
  Router,
  RouterModule,
} from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CustomProductsService } from '../../custom-products/custom-products.service';
import { CustomLandingModule } from '../../custom-landing.module';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslationService, I18nModule } from '@spartacus/core';
import InventoryManagementService from '../../inventory-unpublished-batch/inventory-management.service';
import { CommonModule } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShipmentEditComponent } from '../shipment-edit/shipment-edit.component';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { SharedModule } from '../../../../shared/shared.module';
import { MasterData } from 'src/app/core/model/master-data.model';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { pairwise } from 'rxjs';
import { ShipmentInspectionUpdateComponent } from '../shipment-inspection-update/shipment-inspection-update.component';
import { InspectionScreeningPopUpComponent } from '../inspection-screening-pop-up/inspection-screening-pop-up.component';
import { AttachInvoiceComponent } from '../attach-invoice/attach-invoice.component';
import { PortInvoiceComponent } from '../port-invoice/port-invoice.component';

@Component({
  selector: 'app-shipment-vms-list',
  imports: [
    CustomLandingModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    I18nModule,
    SharedModule,
    InfiniteScrollDirective,
  ],
  templateUrl: './shipment-vms-list.component.html',
  styleUrl: './shipment-vms-list.component.scss',
})
export class ShipmentVmsListComponent implements OnInit {
  title: any = '';
  navigationData: string = '';
  showClear: boolean = false;
  sidebar: boolean;
  AgentsList: any[] = [];
  StatusList: any[] = [];
  portData: any[] = [];
  length: number;
  selectedPort;
  enableLoader: boolean = true;
  activeTab: string = 'Active';
  shipmentTab: string = 'NEW:INPROGRESS:ASSIGNED';
  page = 0;
  reachedToEnd: boolean = false;
  list = true;
  grid = false;
  shipmentdata: any = [];
  shipmentinspectiondata: any = [];
  chinaInstance: any;
  selectedAgent: any;
  selectedStatus: any;
  searchText = null;
  masterData: any;
  fromDetails: any;
  portlength = 0;
  statuslength = 0;
  checkedportform: UntypedFormGroup;
  checkedstatusform: UntypedFormGroup;
  display: any;
  section:any;
  loadingData = false;
  isAgentInvoiceActive: string = 'false';
  constructor(private router: Router, private translation: TranslationService, public modalService: NgbModal,
    private customProductService: CustomProductsService, private toastrService: ToastrService,
    private inventoryService: InventoryManagementService, private cd: ChangeDetectorRef,
    private fb: UntypedFormBuilder, private customProfileService: CustomProfileService,private activatedRoute:ActivatedRoute
  ) {
   
    this.checkedportform = this.fb.group({
      checkArray: this.fb.array([]),
    });
    this.checkedstatusform = this.fb.group({
      checkArray: this.fb.array([]),
    });
  }
  ngOnInit(): void {
    this.customProductService.returnAgentInvoiceActive().subscribe(res=>{
      this.isAgentInvoiceActive = res;
   })
    this.sidebar = true;
    this.filter(true);
    if(this.router.url.includes('portside')){
      this.section = 'portside';
     } else if(this.router.url.includes('bondedwarehouse')){
      this.section = 'bondedwarehouse';
     }
    if (this.router.url == '/shipmentinspection/shipmentinspectionlist/'+ this.section) {
        if(this.section === 'portside'){
      this.translation
        .translate('breadcrumb.inspection.pageTitle')
        .subscribe((res) => {
          this.title = res;
        });
      this.translation
        .translate('breadcrumb.inspection.breadcrumb')
        .subscribe((res) => {
          this.navigationData = res;
        });
      } else if(this.section === 'bondedwarehouse'){
        this.translation
        .translate('breadcrumb.inspectionBondedwarehouse.pageTitle')
        .subscribe((res) => {
          this.title = res;
        });
      this.translation
        .translate('breadcrumb.inspectionBondedwarehouse.breadcrumb')
        .subscribe((res) => {
          this.navigationData = res;
        });

      }
     this.section=== 'portside'? this.display = 'inspectionPage': this.display = 'bondedwarehouseInspectionPage';
    } else if (
      this.router.url == '/shipmentvms/shipmentvmslist/'+this.section ||
      this.router.url == '/shipmentvms/shipmentvmslist/'+this.section + '?from=details'
    ) {
      
      if(this.section === 'portside'){
        this.translation
        .translate('breadcrumb.shipmentList.pageTitle')
        .subscribe((res) => {
          this.title = res;
        });
      this.translation
        .translate('breadcrumb.shipmentList.breadcrumb')
        .subscribe((res) => {
          this.navigationData = res;
        });
      }else if(this.section === 'bondedwarehouse'){
        
        this.translation
        .translate('breadcrumb.shipmentListBondedwarehouse.pageTitle')
        .subscribe((res) => {
          this.title = res;
        });
      this.translation
        .translate('breadcrumb.shipmentListBondedwarehouse.breadcrumb')
        .subscribe((res) => {
          this.navigationData = res;
        });
      }
      
     this.section=== 'portside'? this.display = 'shipmentList': this.display = 'bondedwarehouseShipmentList';
      this.filter(true);
    }
    this.customProfileService.getTemplateData().subscribe((tab) => {
      if (tab == 'Completed') {
        this.activeTab = 'Completed';
        this.shipmentTab = 'COMPLETED';
      } else {
        this.activeTab = 'Active';
        this.shipmentTab = 'NEW:INPROGRESS:ASSIGNED';
      }
    });
    this.customProductService.languageChange$
      .pipe(pairwise())
      .subscribe(([previous, current]) => {
        this.enableLoader = true;
        if (current != null) {
          if (previous !== current) {
            this.enableLoader = true;
            if (
              this.router.url === '/shipmentvms/shipmentvmslist/'+this.section ||
              this.router.url === '/shipmentinspection/shipmentinspectionlist/'+this.section || this.router.url == '/shipmentvms/shipmentvmslist/'+this.section + '?from=details'
            ) {
              //this.activeTab = 'Active';
              //this.shipmentTab = 'NEW:INPROGRESS:ASSIGNED';
             // setTimeout(() => {
                this.getMasterData();
             // }, 1000);
            }
          }
        }
      });
      this.getMasterData();
  }
  filter(initial:boolean) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.fromDetails = params['from'] === 'details';
    });
    if (!this.fromDetails) {
      this.clearAllFilter(initial);
    }
    this.customProfileService.getports().subscribe((data) => {
      if (data?.length) {
        this.selectedPort = data;
        this.changePorts(initial);
      }
    });
    this.customProfileService.getagents().subscribe((data) => {
      if (data?.length) {
        this.selectedAgent = data;
        this.changeAgents(initial);
      }
    });
    this.customProfileService.getstatus().subscribe((data) => {
      if (data?.length) {
        this.selectedStatus = data;
        this.changeStatus(initial);
      }
    });
    this.customProfileService.getsearch().subscribe((data) => {
      if (data?.length) {
        this.searchText = data;
      }
    });
  }
  getMasterData(): void {
    this.enableLoader = true;
    let toastshown = false;
    let pageid = '';
    let displaystr;
    // for ports inside filters if want both combined list portside and seabourne then send PS:BW
    this.section === 'bondedwarehouse'? displaystr = 'BW' : displaystr = 'PS';
    if (this.display === 'shipmentList' || this.display === 'bondedwarehouseShipmentList') {
      this.customProfileService
        .getShipmentfilters(pageid,displaystr)
        .subscribe((res: MasterData) => {
          if (res) {
            this.enableLoader = false;
            this.masterData = res;
            this.AgentsList = this.masterData.partners;
            this.portData = this.masterData.ports;
            this.StatusList = this.masterData.shipmentStatus;
            this.getShipmentdata();
          }
          (error) => {
            this.enableLoader = false;
            // this.toastrService.show('Something went wrong please contact support team.')
            this.translation
              .translate('shipment.erroroccuredmessage')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              });
          };
        });
    } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
      this.customProfileService
        .getShipmentInspectionfilters(displaystr)
        .subscribe((res: MasterData) => {
          if (res) {
            this.enableLoader = false;
            this.masterData = res;
            this.AgentsList = this.masterData.partners;
            this.portData = this.masterData.ports;
            this.StatusList = this.masterData.shipmentStatus;
            this.getShipmentInspectionData();
          }
          (error) => {
            this.enableLoader = false;
            // this.toastrService.show('Something went wrong please contact support team.')
            this.translation
              .translate('shipment.erroroccuredmessage')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              });
          };
        });
    }
  }
  getShipmentdata() {
    this.enableLoader = true;
    this.page = 0;
    const requestParams = {
      port: this.selectedPort?.length ? this.selectedPort : '',
      currentPage: this.page,
      pageSize: 10,
      status: this.selectedStatus?.length
        ? this.selectedStatus
        : this.shipmentTab,
    };
    let toastshown = false;
    this.customProductService
      .getShipmentListData(requestParams, this.searchText,this.display)
      .subscribe(
        (data) => {
          this.shipmentdata = data.shipments;
          this.enableLoader = false;
          this.cd.detectChanges();
        },
        (err) => {
          // this.toastrService.show('Shipment list is having some error.')
          this.translation
            .translate('shipment.erroroccuredmessage')
            .subscribe((res) => {
              if (!toastshown) {
                this.toastrService.show(res);
                toastshown = true;
              }
            });
          this.enableLoader = false;
        },
      );
  }
  convertDateOnly(dateString): any {
    if (dateString) {
      return dateString.replace(/-/g, '/');
    }
  }
  private buildRequestParams(): any {
    return {
      port: this.selectedPort?.length ? this.selectedPort : '',
      currentPage: this.page,
      pageSize: 10,
      status: this.selectedStatus?.length ? this.selectedStatus : this.shipmentTab,
    };
  }
  getShipmentInspectionData(){
    this.enableLoader = true;
    this.page = 0
    const requestParams = this.buildRequestParams();
    this.customProductService.getShipmentInspectionListData(requestParams, this.searchText,this.display).subscribe((data) => {
      this.shipmentinspectiondata = data.shipments;
      
      this.enableLoader = false;
      this.cd.detectChanges()
    }, err => {
      this.toastrService.show('Shipment inspection list is having some error.')
      this.enableLoader = false;
    })
  }
  NavigateToDetails() {
    console.log(this.router);
    this.router.navigate(['/shipmentvms/vmsdetails']);
  }
  gotoDeatils(shipData, vieworUpdate) {
    this.customProfileService.setports(this.selectedPort);
    this.customProfileService.setagents(this.selectedAgent);
    this.customProfileService.setstatus(this.selectedStatus);
    this.customProfileService.setsearch(this.searchText);
    this.router.navigate(
      ['/shipmentvms/vmsdetails/' + shipData.nominationNumber+'/'+ this.section],
      {
        queryParams: {
          nominationItemNumber: shipData.nominationItemNumber,
          nominationKey: shipData.nominationKey,
          fromscreen: vieworUpdate == 'update' ? 'updateInfo' : undefined,
        },
      },
    );
    if (this.activeTab === 'Active') {
      this.customProfileService.setTemplateData('Active');
    } else {
      this.customProfileService.setTemplateData('Completed');
    }
  }
  changePorts(initial: boolean) {
    if (
      (this.selectedPort?.length == 0 ||
        this.selectedPort?.length == undefined) &&
      (this.selectedAgent?.length == 0 ||
        this.selectedAgent?.length == undefined) &&
      (this.selectedStatus?.length == 0 ||
        this.selectedStatus?.length == undefined)
    ) {
      this.showClear = false;
    } else {
      this.showClear = true;
    }
    this.reachedToEnd = false;
    if (!initial) {
      if (this.display === 'shipmentList'|| this.display === 'bondedwarehouseShipmentList') {
        this.getShipmentdata();
      } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
        this.getShipmentInspectionData();
      }
    }
  }
  changeAgents(initial: boolean) {
    if (
      (this.selectedPort?.length == 0 ||
        this.selectedPort?.length == undefined) &&
      (this.selectedAgent?.length == 0 ||
        this.selectedAgent?.length == undefined) &&
      (this.selectedStatus?.length == 0 ||
        this.selectedStatus?.length == undefined)
    ) {
      this.showClear = false;
    } else {
      this.showClear = true;
    }
    this.reachedToEnd = false;
    if (!initial) {
      if (this.display === 'shipmentList'|| this.display === 'bondedwarehouseShipmentList') {
        this.getShipmentdata();
      } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
        this.getShipmentInspectionData();
      }
    }
  }
  changeStatus(initial: boolean) {
    if (
      (this.selectedPort?.length == 0 ||
        this.selectedPort?.length == undefined) &&
      (this.selectedAgent?.length == 0 ||
        this.selectedAgent?.length == undefined) &&
      (this.selectedStatus?.length == 0 ||
        this.selectedStatus?.length == undefined)
    ) {
      this.showClear = false;
    } else {
      this.showClear = true;
    }
    this.reachedToEnd = false;
    if (!initial) {
      if (this.display === 'shipmentList'|| this.display === 'bondedwarehouseShipmentList') {
        this.getShipmentdata();
      } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
        this.getShipmentInspectionData();
      }
    }
  }
  onScrollGrid(): any {
    if (!this.loadingData) {
      this.loadMoreData();
    }
  }
  loadMoreData() {
    this.loadingData = true;
    // if (!this.reachedToEnd) {
    //   setTimeout(() => {
    this.page += 1;
    const requestParams = {
      port: this.selectedPort?.length ? this.selectedPort : '',
      currentPage: this.page,
      pageSize: 10,
      status: this.selectedStatus?.length
        ? this.selectedStatus
        : this.shipmentTab,
      b2bUnitId: this.selectedAgent?.length ? this.selectedAgent : '',
    };
    let toastshown = false;

    if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
      this.customProductService
        .getShipmentInspectionListData(requestParams, this.searchText, this.display)
        .subscribe(
          (data) => {
            this.loadingData = false;
            if (data.shipments?.length) {
              this.shipmentinspectiondata = this.shipmentinspectiondata.concat(
                data.shipments,
              );
              this.enableLoader = false;
            } else {
              this.reachedToEnd = true;
              this.enableLoader = false;
            }
          },
          (err) => {
            // this.toastrService.show('Shipment list is having some error.')
            this.translation
              .translate('shipment.erroroccuredmessage')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              });
            this.enableLoader = false;
          },
        );
    } else if (this.display === 'shipmentList' || this.display === 'bondedwarehouseShipmentList') {
      this.customProductService
        .getShipmentListData(requestParams, this.searchText)
        .subscribe(
          (data) => {
            this.loadingData = false;
            if (data.shipments?.length) {
              this.shipmentdata = this.shipmentdata.concat(data.shipments);
              this.enableLoader = false;
            } else {
              this.reachedToEnd = true;
              this.enableLoader = false;
            }
          },
          (err) => {
            // this.toastrService.show('Shipment list is having some error.')
            this.translation
              .translate('shipment.erroroccuredmessage')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              });
            this.enableLoader = false;
          },
        );
    }
    // }, 1000);
    // }
  }
  clearAllFilter(initial:boolean): any {
    this.showClear = false;
    this.selectedPort = [];
    this.selectedAgent = [];
    this.selectedStatus = [];
    this.searchText = null;
    this.customProfileService.resetportFilter();
    this.customProfileService.resetagentFilter();
    this.customProfileService.resetsearchFilter();
    this.customProfileService.resetstatusFilter();
    this.customProfileService.resetTemplateData();
    if (!initial) {
      if (this.display === 'shipmentList' || this.display === 'bondedwarehouseShipmentList') {
        this.getShipmentdata();
      } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
        this.getShipmentInspectionData();
      }
    }
  
  }
  search() {
    this.searchText.toLowerCase();
    if (this.searchText.length >= 7) {
      // this.getShipmentdata();
      if (this.display === 'shipmentList' || this.display === 'bondedwarehouseShipmentList') {
        this.getShipmentdata();
      } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
        this.getShipmentInspectionData();
      }
    } else if (this.searchText.length == 0) {
      // this.getShipmentdata();
      if (this.display === 'shipmentList' || this.display === 'bondedwarehouseShipmentList') {
        this.getShipmentdata();
      } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
        this.getShipmentInspectionData();
      }
    }
  }
  getResults(): any {
    this.closebar();
    this.filterData();
  }

  filterData() {
    this.enableLoader = true;
    // this.getShipmentdata();
    if (this.display === 'shipmentList' || this.display === 'bondedwarehouseShipmentList') {
      this.getShipmentdata();
    } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
      this.getShipmentInspectionData();
    }
  }
  clearFilterDataMobile(event): void {
    this.closebar();
    const checked = false;
    this.portData.forEach((item) => (item.selected = checked));
    this.StatusList.forEach((item) => (item.selected = checked));
    this.selectedPort = [];
    this.selectedAgent = [];
    this.selectedStatus = [];
    this.searchText = null;
    // this.getShipmentdata();
    if (this.display === 'shipmentList' || this.display === 'bondedwarehouseShipmentList') {
      this.getShipmentdata();
    } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
      this.getShipmentInspectionData();
    }
  }

  closebar() {
    this.sidebar = true;
  }
  filtersidebar() {
    this.sidebar = false;
  }

  portsmobileFilter(e, id) {
    this.portlength = 1;
    const checkArray: UntypedFormArray = this.checkedportform.get(
      'checkArray',
    ) as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.portlength = 0;
    }
    this.selectedPort = checkArray.value;
  }
  statusmobileFilter(e, id) {
    this.statuslength = 1;
    const checkArray: UntypedFormArray = this.checkedstatusform.get(
      'checkArray',
    ) as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.statuslength = 0;
    }
    this.selectedStatus = checkArray.value;
  }
  changeTab(data, showMsg?): any {
    this.enableLoader = true;
    this.activeTab = data;
    this.page = 0;
    this.reachedToEnd = false;
    if (this.activeTab === 'Active') {
      this.shipmentTab = 'NEW:INPROGRESS:ASSIGNED';
      // show active tab
    } else if (this.activeTab === 'Completed') {
      // show completed tab
      this.shipmentTab = 'COMPLETED';
    }
    if (this.display === 'shipmentList' || this.display === 'bondedwarehouseShipmentList') {
      this.getShipmentdata();
    } else if (this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage') {
      this.getShipmentInspectionData();
    }
  }
  omitSpecialChar(event): any {
    const k = event.charCode;
    if (k === 46) {
      return false;
    }
    return this.isValidLetter(k);
  }
  isValidLetter(k): any {
    return (k = 47);
  }
  updateInspectionInfo(inspectionData) {
    const ModalRef = this.modalService.open(ShipmentInspectionUpdateComponent, {
      centered: true,
      size: 'md',
    });
    ModalRef.componentInstance.updateInspectionData = inspectionData;
    ModalRef.componentInstance.activeTab = this.activeTab;
    ModalRef.componentInstance.requestParams = this.buildRequestParams();
    ModalRef.componentInstance.searchText = this.searchText;
    ModalRef.componentInstance.azureValidationRemark = inspectionData.azureValidationRemark;
    ModalRef.componentInstance.passActiveTab.subscribe((receivedEntry) => {
      console.log(receivedEntry);
      if (receivedEntry === 'Completed') {
        this.changeTab('Completed');
      } else {
        this.changeTab('Active');
      }
    });
    ModalRef.result.then((res) => {
      if (res === 'saved') {
      }
    });
  }
  donwloadShipmentRpeort(reportType) {
    let toastshown = false;
    if (reportType === 'shipmentlist_report' || reportType === 'INSP_REPORT' || reportType ==='bonded_warehouse_inspection_report' || reportType === 'seaborne_shipmentlist_report') {
      this.enableLoader = true;
      this.customProfileService.exportReport(reportType).subscribe(
        (response) => {
          if (response.status == 'success') {
            const ref = document.createElement('a');
            ref.href = `data:application/xlsx;base64,${response.code}`;
            if (reportType === 'shipmentlist_report') {
              ref.download = `ShipmentReport.xlsx`;
            } else if (reportType === 'INSP_REPORT') {
              ref.download = `InspectionReport.xlsx`;
            }else if (reportType === 'seaborne_shipmentlist_report') {
              ref.download = `BW-Shipment Report.xlsx`;
            }else if (reportType === 'bonded_warehouse_inspection_report') {
              ref.download = `BW-Inspection Report.xlsx`;
            }
            ref.click();
            this.enableLoader = false;
            this.translation
              .translate('shipment.downloaddoc')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              });
          } else {
            this.enableLoader = false;
            this.toastrService.show(response.status);
          }
        },
        (err) => {
          this.enableLoader = false;
          // this.toastrService.show('Download unsuccessful, please contact support team.');
          this.translation
            .translate('shipment.downloadunsuccess')
            .subscribe((res) => {
              if (!toastshown) {
                this.toastrService.show(res);
              }
            });
        },
      );
    }
  }
  openCargoAgentPopup(userType: string, shipdata?: any){
    if(this.display === 'inspectionPage' || this.display === 'bondedwarehouseInspectionPage'){
    const modalRef = this.modalService.open(InspectionScreeningPopUpComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.userType = userType;
    const members = userType === 'screening_operator'? shipdata?.screeningAgent?.members : shipdata?.cargoAgent?.members;
    const agentName = userType === 'screening_operator'? shipdata?.screeningAgent?.name: shipdata?.cargoAgent?.name;
    modalRef.componentInstance.cargoAgentMembers = members;
    modalRef.componentInstance.agentName = agentName;
	}
  }
  openInvoices(data: any){
    const modalref = this.modalService.open(AttachInvoiceComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });
    modalref.componentInstance.display='invoices';
    modalref.componentInstance.batchData = data;
    modalref.componentInstance.useCaseType = this.display === 'inspectionPage' ? 'INSPECTIONINVOICE_UC3' : 'CARGOARRIVALINVOICE_UC3';
  }
  openPortInvoices(data: any){
    const modalref = this.modalService.open(PortInvoiceComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });
    modalref.componentInstance.display='portInvoices';
    modalref.componentInstance.batchData = data;
    // modalref.componentInstance.useCaseType = this.display === 'inspectionPage' ? 'INSPECTIONINVOICE_UC3' : 'CARGOARRIVALINVOICE_UC3';
   }
  }
